import dbCompareListPage from "./pages/dbCompareListPage.vue"


export default{
dbCompareListPage,
}